import type { Ticket } from "./types";

// Display URLs are separate from the internal ID used by APIs and realtime.
// Older API responses may expose only customerUrl; never fall back to ticket.id.
export function customerTicketPath(ticket: Pick<Ticket, "publicId" | "customerUrl">): string {
  if (ticket.publicId) return `/tickets/${encodeURIComponent(ticket.publicId)}`;
  if (ticket.customerUrl) {
    try {
      const path = new URL(ticket.customerUrl, "https://support.invalid").pathname;
      if (/^\/tickets\/[a-zA-Z0-9-]+\/?$/.test(path)) return path.replace(/\/$/, "");
    } catch { /* Missing valid public link: use the customer's ticket list. */ }
  }
  return "/tickets";
}
